import { useYoloModal } from 'lib/yoloModals/useYoloModal'
import { useCallback, useEffect } from 'react'
import { SignUpForm } from './SignUpForm'
import { Close } from './SignUpModalCSS.styled'
import { SignUpModalCSS } from './SignUpModalCSS.styled'

const SIGN_IN_MODAL_OBJ = {
  // this component will receive `closeModal` prop to close programmatically the modal
  show: true,
  id: 'signIn',
}

export const SignUpModal = ({ closeModal, referralCode, onSignedUp }) => {
  const { updateModal } = useYoloModal()

  useEffect(() => {}, [])

  const openSignInModal = useCallback(
    () => {
      updateModal({
        ...SIGN_IN_MODAL_OBJ,
      })
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )
  return (
    <SignUpModalCSS>
      <div className='popUpContainer user-signin variable-width'>
        <article>
          <Close name='close2' masking onClick={closeModal} />
          <h1>Register</h1>
          <h2>New users register for a YOLOREKT account</h2>
          <div className='signin_modal_tabs_wrapper'>
            {/* <Tabs closeModal={closeModal} /> */}

            <div className='panels'>
              <SignUpForm referralCode={referralCode} openSignInModal={openSignInModal} onSignedUp={onSignedUp} />
              <div className='signin_marketing_panel'>
                <div className='client_logo wallstreetbets' />
                {/* <img src="resources/images/wsb/wsb_logo_neon.png"> */}
                {/* </div> */}

                <div className='user_alternate_access'>
                  <span>Already have an account?</span>
                  <button onClick={openSignInModal}>Sign In</button>
                </div>

                <div className='access_statement'>
                  By accessing this site, I attest that I am at least 18 years old and have read the{' '}
                  <a href='https://docs.yolorekt.finance/legal/terms-of-service' target='blank'>
                    Terms &amp; Conditions
                  </a>
                  .
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </SignUpModalCSS>
  )
}
